var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container" },
    [
      _c("fa", {
        staticClass: "icons",
        attrs: { icon: "filter" },
        on: { click: _vm.toggleSideMenu },
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "side-nav-transition" } }, [
        _c(
          "div",
          { staticClass: "side-nav-menu", class: { visible: _vm.showFilters } },
          [
            _c("div", { staticClass: "logo" }, [
              _c("img", {
                attrs: { src: "img/software-logo.png", alt: "Logo" },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "menu-items is-flex is-flex-direction-column is-justify-content-center is-align-items-center",
              },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "menu-item" },
                  [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.expandSubitems(index)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.title) +
                            "\n            "
                        ),
                        _c("fa", {
                          attrs: {
                            icon: _vm.getIconForMenuItem(item.expanded),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "subitems-transition" } },
                      [
                        item.expanded
                          ? _c(
                              "ul",
                              _vm._l(item.subitems, function (subitem) {
                                return _c("li", { key: subitem.title }, [
                                  _vm._v(_vm._s(subitem.title)),
                                ])
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("fa", {
              staticClass: "icons close-icon",
              attrs: { icon: "xmark" },
              on: { click: _vm.toggleSideMenu },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }